export const CONFIG_PRODUCT_FORM = "configProductForm";
export const DELETE_PRODUCTS_FORM = "configDeleteProductsForm";
export const IMPORTATION_PRODUCTS_FORM = "configImporationProductsForm";
export const PRODUCT_CATEGORY_FORM = "configProductCategoryForm";
